<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { LightboxGallery, GalleryImage, GalleryThumbnail } from 'svelte-lightbox';

	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let galleries = data?.gallery;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Gallery - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="http://50.6.171.246:5000/gallery" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src="/img/bg-header-gallery.webp"
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Gallery</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<!-- list gallery -->
	<div class="container p-0 py-md-5 py-5" id="list-gallery">
		<div class="row g-0 mb-md-4">
			<div class="col-md-12 text-center mb-md-0 mb-3">
				<p class="mb-md-0 mb-1 main-color fs-1 ff-lola-bir">{$_('gallery_title_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
			</div>
		</div>
		<div class="row g-0 py-md-4 py-3">
			<div class="col-md-12">
				<div class="col-md-12">
					<div id="exTab1" class="container">
						<ul
							class="nav nav-pills mb-md-0 mb-2 justify-content-center"
							id="pills-tab"
							role="tablist"
						>
							<li class="nav-item" role="presentation">
								<a
									class="nav-link mx-1 rounded-2 text-capitalize fw-semibold active position-relative mb-2"
									id="pills-all-tab"
									data-bs-toggle="pill"
									data-bs-target="#pills-all"
									role="tab"
									aria-controls="pills-all"
									aria-selected="true">{$_('gallery_cat_all')}</a
								>
							</li>
							{#each galleries as gallery}
								<li class="nav-item" role="presentation">
									<a
										class="nav-link mx-1 rounded-2 text-capitalize fw-semibold position-relative mb-2"
										id="pills-{gallery.slug}-tab"
										data-bs-toggle="pill"
										data-bs-target="#pills-{gallery.slug}"
										role="tab"
										aria-controls="pills-{gallery.slug}"
										aria-selected="true">{gallery.name}</a
									>
								</li>
							{/each}
						</ul>
						<div class="tab-content p-md-3 p-1" id="pills-tabContent">
							<div
								class="tab-pane fade show active"
								id="pills-all"
								role="tabpanel"
								aria-labelledby="pills-all-tab"
							>
								<div class="row g-0">
									<LightboxGallery>
										<svelte:fragment slot="thumbnail">
											{#each galleries as gallery}
												{#each gallery.featured_images as img}
													<div class="col-md-3 col-6 p-md-2 p-2">
														<GalleryThumbnail>
															<div class="ratio ratio-16x9">
																<img
																	src={img.path}
																	class="w-100 h-100 object-fit-cover"
																	alt="Holiday Inn Resorts Nusa Dua"
																/>
															</div>
														</GalleryThumbnail>
													</div>
												{/each}
											{/each}
										</svelte:fragment>
										{#each galleries as gallery}
											{#each gallery.featured_images as img}
												<GalleryImage>
													<img alt="Holiday Inn Resorts Nusa Dua" src={img.path} />
													{#if img.title != null}
														<p class="text-white text-center ff-helvetica pt-2">{img.title}</p>
													{/if}
												</GalleryImage>
											{/each}
										{/each}
									</LightboxGallery>
								</div>
							</div>
							{#each galleries as gallery}
								<div
									class="tab-pane fade"
									id="pills-{gallery.slug}"
									role="tabpanel"
									aria-labelledby="pills-{gallery.slug}-tab"
								>
									<div class="row g-0">
										<LightboxGallery>
											<svelte:fragment slot="thumbnail">
												{#each gallery.featured_images as img}
													<div class="col-md-3 col-6 p-md-2 p-2">
														<GalleryThumbnail>
															<div class="ratio ratio-16x9">
																<img
																	src={img.path}
																	class="w-100 h-100 object-fit-cover"
																	alt="Holiday Inn Resorts Nusa Dua"
																/>
															</div>
														</GalleryThumbnail>
													</div>
												{/each}
											</svelte:fragment>
											{#each gallery.featured_images as img}
												<GalleryImage>
													<img alt="Holiday Inn Resorts Nusa Dua" src={img.path} />
													{#if img.title != null}
														<p class="text-white text-center ff-helvetica pt-2">{img.title}</p>
													{/if}
												</GalleryImage>
											{/each}
										</LightboxGallery>
									</div>
								</div>
							{/each}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.line {
		border-bottom: 2px solid #757fbd;
		width: 10%;
	}
	.nav-pills .nav-link.active {
		color: white;
		border: 1px solid #757fbd;
		background-color: #757fbd;
		transition: 0.3s all;
	}
	.nav-pills .nav-link {
		color: #757fbd;
		border: 1px solid #757fbd;
		cursor: pointer;
		transition: 0.3s all;
	}
	.nav-pills .nav-link:hover {
		color: white;
		border: 1px solid #757fbd;
		background-color: #757fbd;
		transition: 0.3s all;
	}
	@media (max-width: 600px) {
		.line {
			border-bottom: 2px solid #757fbd;
			width: 15%;
		}
	}
</style>
